import React, { useEffect, useState } from 'react';
import Paragraph from '../../Common/Atoms/Paragraph';
import Button from '../../Common/Modules/Button';
import CallbackIconTextButton from '../../Common/Modules/CallbackIconTextButton';
import GoogleService from '../../../Services/GoogleService';
import Datadog from '../../../Helpers/Datadog';
import { CustomEventsDatadog, CustomEventsErrorDatadog } from '../../../Config/Datadog';
import Link from '../../Common/Atoms/Link';

const Google = ({ usuario, isLoading, onError, tieneClave, vinculadoOtraRed  }) => {
    const [estado, setEstado] = useState({
        settings: { gmId: process.env.REACT_APP_GOOGLEAPIID },
        profile: undefined,
        error: undefined,
        account: usuario,
        image: false,
        imageurl: 'https://mail.google.com/mail/u/0/?logout&hl=en',
    });
    const gmId = process.env.REACT_APP_GOOGLEAPIID;
    const vinculadoGoogle = estado.account.usuario_gmail_id ? true : false;
    const logged = (estado && estado.profile && estado.profile.displayName) != undefined;
    const profileName = logged ? estado.profile.displayName : '';
    const [timerHandle, setTimerHandle] = useState();
    //crear dos usestates para vinculados, y los seteo despues de vinc o desvinc, luego los uso como condicion en button

    useEffect(() => {
        if (!gapi) throw new Error('gapi is not defined');
        gapi && gapi.load('client:auth2', initializeGoogleAPI());

        setTimerHandle(
            setTimeout(() => {
                handleOnLoad(undefined);
            }, 500)
        );
    }, []);

    const initializeGoogleAPI = () => {
        isLoading(true);
        const auth2 = gapi.auth2.init({
            client_id: gmId,
        });
        const access = gapi && gapi.auth.getToken();
        if (access) {
            handleOnLoad(undefined); //set profile
        }
        isLoading(false);
    };

    const handleOnLoad = (e) => {
        gapi.client.load('plus', 'v1', () => {
            const request = gapi.client.plus.people.get({ userId: 'me' });
            request.execute((profile) => {
                setEstado({ ...estado, profile: profile });
            });
        });
    };

    const asociarGMProcess = () => {
        isLoading(true);
        const response = gapi.auth2.getAuthInstance().currentUser.get();
        let profile = response.getBasicProfile();
        const data = {
            usuarioGmailId: profile.getId(),
            accessToken: response.getAuthResponse().id_token,
        };

        //---Cambiado
        GoogleService.asociarGmail(data)
            .then((apiResponse) => {
                if (apiResponse && apiResponse.code) {
                    const inv = apiResponse.response ? apiResponse.response : undefined;

                    if (apiResponse.code == '0000' || apiResponse.code == '0020') {
                        Datadog.trackCustomEvent(CustomEventsDatadog.vincularRedSocial, { redSocial: 'Google' });
                        //TODO: enviar evento a padre porque componente facebook depende de ésta vinculación
                        //en vez de hacer un reload
                        location.reload();
                    } else {
                        Datadog.trackCustomEventWarning(CustomEventsErrorDatadog.errorVincularRedSocial, { redSocial: 'Google' });
                        setEstado({ ...estado, error: apiResponse.message });
                        isLoading(false);
                        const errorMessage = apiResponse.code === '0027' ? 'El perfil de Google seleccionado ya se encuentra vinculado a otra cuenta' : apiResponse.message;
                        onError(errorMessage);
                    }
                }
            })
            .catch((reason) => {
                console.log(`rejected by ${reason}`);
                isLoading(false);
            });

        if (profile && !profile.displayName) {
            //si no viene DisplayName, ver si viene Ad, si viene Ad poner el valor en DisplayNane
            profile.id = profile.ZU;
            profile.displayName = profile.Ad;
            profile.name = {
                familyName: profile.DU,
                givenName: profile.DW,
            };
            profile.image = {
                url: profile.gL,
                isDefault: true,
            };
            profile.emails = [
                {
                    value: profile.zu,
                    type: 'ACCOUNT',
                },
            ];
            profile.language = 'en';
        }
        setEstado({ ...estado, profile: profile });
        isLoading(false);
    };

    const asociarGoogleAccount = (e) => {
        isLoading(true);
        gapi &&
            gapi.auth2.getAuthInstance().isSignedIn.listen((isSignedIn) => {
                if (isSignedIn) {
                    // console.log("signed");
                    asociarGMProcess();
                }
                isLoading(false);
            });

        if (gapi) {
            if (!gapi.auth2.getAuthInstance().isSignedIn.get()) {
                gapi.auth2.getAuthInstance().signIn();
                isLoading(false);
            } else {
                asociarGMProcess();
                isLoading(false);
            }
        }
    };

    const desasociarGoogleAccount = (e) => {
        isLoading(true);
        GoogleService.desasociarGmail()
            .then((response) => {
                console.log(`Cuenta gmail desasociada!`);
                Datadog.trackCustomEvent(CustomEventsDatadog.desvincularRedSocial, { redSocial: 'Google' });
                setEstado({
                    ...estado, account: {
                        ...estado.account,
                        usuario_gmail_id: undefined,
                        usuario_gmail_access_token: undefined,
                    }
                })
                isLoading(false);
                //TODO: enviar evento a padre porque componente facebook depende de ésta vinculación
                //en vez de hacer un reload
                location.reload();
            })
            .catch((reason) => {
                Datadog.trackCustomEventWarning(CustomEventsErrorDatadog.errorDesvincularRedSocial, { redSocial: 'Google' });
                console.log(`rejected by ${reason}`);
                setEstado({ ...estado, error: reason })
                isLoading(false);
            });
    };

    const logout = (e) => {
        isLoading(true);
        gapi.auth2.getAuthInstance().signOut();
        gapi.auth2.getAuthInstance().disconnect();
        setEstado({ image: true })
        isLoading(false);
        location.reload();
    };

    return (
        <CallbackIconTextButton
            mod={'--ai-center --mb-32'}
            icon={
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M29.9999 16.3105C29.9999 15.1593 29.9047 14.3193 29.6986 13.4482H16.2988V18.6438H24.1642C24.0057 19.935 23.1494 21.8794 21.2464 23.1861L21.2197 23.3601L25.4564 26.5797L25.75 26.6085C28.4458 24.1662 29.9999 20.5728 29.9999 16.3105Z"
                        fill="#4285F4"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.2856 29.9998C20.1427 29.9998 23.3808 28.7553 25.746 26.6086L21.238 23.1863C20.0316 24.0107 18.4125 24.5863 16.2856 24.5863C12.5078 24.5863 9.30142 22.1441 8.15841 18.7686L7.99092 18.7825L3.58112 22.127L3.52344 22.2841C5.87264 26.8575 10.6982 29.9998 16.2856 29.9998Z"
                        fill="#34A853"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.15865 18.7597C7.8571 17.8895 7.6825 16.957 7.6825 15.9936C7.6825 15.0301 7.85702 14.0978 8.14279 13.2276L8.13482 13.0422L3.66982 9.64746L3.52376 9.71552C2.55552 11.6114 2 13.7403 2 15.9935C2 18.2468 2.55561 20.3756 3.52376 22.2715L8.15873 18.7596L8.15865 18.7597Z"
                        fill="#FBBC04"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.2856 7.41329C18.9681 7.41329 20.7776 8.5489 21.8094 9.49787L25.8412 5.64003C23.3651 3.38442 20.1427 2 16.2856 2C10.6982 2 5.87272 5.14223 3.52344 9.7156L8.14255 13.2313C9.30142 9.85571 12.5078 7.41338 16.2856 7.41338V7.41329Z"
                        fill="#EA4335"
                    />
                </svg>
            }
            text={
                <>
                    <Paragraph size="--twoxs" mod="--font-bold --arial">
                        Google
                    </Paragraph>
                    {vinculadoGoogle ? (
                        <Paragraph size="--fourxs" mod="--arial --mb-8">
                            Cuenta ya vinculada
                        </Paragraph>
                    ) : logged ? (
                        <p className="com-paragraph --fourxs --arial --mb-8">
                            Si no sos {profileName} hacé <Link onClick={logout}>clic aquí</Link>
                        </p>
                    ) : null}
                </>
            }
            button={
                (vinculadoGoogle && (vinculadoOtraRed || tieneClave)) ? //vinculado: vinculada con gmail y con facebook admite desvinculación con google
                    <Button
                        onClick={desasociarGoogleAccount}
                        href={'#'}
                        label="DESVINCULAR"
                        className="state--w100 --mb-0"
                        mod="tertiary"
                        isFirstPositioned={true}
                    /> :
                    !vinculadoGoogle && //si no está vinculado
                    <Button
                        onClick={asociarGoogleAccount}
                        href={'#'}
                        label="VINCULAR"
                        aria-label="Vincular con la cuenta de Google"
                        className="state--w100 --mb-0"
                        mod="tertiary"
                        isFirstPositioned={true}
                    />
            }
        />
    );
};

export default Google;